<template>
  <div class="topBox">
    <div class="top_box_text">{{text}}</div>
    <div class="top_box_data">{{parseDataType(topData)}}</div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { parseDataType } from '@/assets/func'
  
  export default {
    name: 'topBox',
    props: {
      data: Number,
      text: String
    },
    computed: {
      topData () { // data -> null or undefine이면 0 아니면 data
        if (_.isNil(this.data)) {
          return 0
        } else {
          return this.data
        }
      }
    },
    methods: {
      parseDataType (data) {
        return parseDataType(data)
      }
    }
  }
</script>

<style scoped>
  .topBox {
    position: relative;
    display: inline-block;
    margin-right: 10px;
    width: calc(25% - 7.5px);
    height: 60px;
    border-radius: 7px;
    color: #fff;
  }
  .topBox:nth-last-child(1) {
    margin-right: 0;
  }
  .top_box_text {
    position: absolute;
    font-size: 20px;
    top: 10px;
    left: 20px;
    font-weight: 500;
  }
  .top_box_data {
    position: absolute;
    font-size: 25px;
    bottom: 10px;
    right: 30px;
    font-weight: 600;
  }
  @media screen and (max-width: 1200px) {
    .topBox {
      width: calc(50% - 5px);
      margin-bottom: 5px;
    }
    .topBox:nth-child(2) {
      margin-right: 0;
    }
  }

  @media screen and (max-width: 800px) {
    .topBox {
      width: calc(100% - 10px);
      height: 7vh;
      margin-left: 5px;
      margin-right: 5px;
    }
    .top_box_text {
      font-size: 18px;
      top: 50%;
      margin-top: -15px;
      left: 10px;
    }
    .top_box_data {
      font-size: 18px;
      bottom: 50%;
      margin-bottom: -15px;
      right: 15px;
    }
  }

</style>


// WEBPACK FOOTER //
// TopBox.vue?dda99c76